export default __webpack_public_path__ + "static/media/greenMark.d716f16c.svg";